import React from "react";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white text-center py-4 mt-5">
      <div className="container">
        {/* ✅ Copyright */}
        <p className="mb-2">
          © {year} Barbara PH Properties. All rights reserved.
        </p>

        {/* ✅ Contact Us via Email */}
        <p>
          Contact us:{" "}
          <a
            href="mailto:info@barbaraphproperties.com"
            className="text-white fw-bold"
            aria-label="Email Barbara PH Properties"
          >
            info@barbaraphproperties.com
          </a>
        </p>

        {/* ✅ Social Links */}
        <div className="mt-2">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white me-3"
            aria-label="Visit our Facebook page"
          >
            Facebook
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white me-3"
            aria-label="Visit our Twitter profile"
          >
            Twitter
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white"
            aria-label="Visit our Instagram profile"
          >
            Instagram
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
